export const START_LOADING = "START_LOADING";
export const FINISH_LOADING = "FINISH_LOADING";
export const REMOVE_ANIMATION = "REMOVE_ANIMATION";
